// tiptap-markdown attaches its serializer to `editor.storage` at runtime but ships no types for
// it, so the cast lives here rather than at every call site.
interface MarkdownStorage {
  markdown: { getMarkdown(): string }
}

export function getMarkdown(editor: { storage: unknown }): string {
  return (editor.storage as MarkdownStorage).markdown.getMarkdown()
}
